<template>
    <div id="feide-login-modal" class="flex justify-center items-start">
        <div @click="closeByBackdrop" class="backdrop"></div>
        <div class="popup-content relative">
            <InnerLoader v-if="isLoading" />
            <div class="popup-header flex justify-between items-center">
                <div></div>
                <div
                    v-if="isDisabledClose"
                    @click="closePopup"
                    class="close-button flex justify-center items-center cursor-pointer"
                >
                    <i class="fas fa-times"></i>
                </div>
            </div>
            <div class="popup-body">
                <div class="login-box text-center">
                    <div class="header-login">
                        <h1 class="text-2xl mt-1 my-2">{{ $t('auth_login_button_login') }}</h1>
                        <p v-html="$t('login_with_feide_sub_title')" style="font-size: 1rem"></p>
                        <div
                            class="border border-solid text-green px-3 py-1 rounded-full inline-flex items-center justify-center mt-2"
                            style="font-size: 0.7rem"
                        >
                            <div class="flex h-4 inline-flex">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    fill="currentColor"
                                    class="h-full"
                                >
                                    <path
                                        d="M466.5 83.7l-192-80a48.2 48.2 0 0 0 -36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
                                    ></path>
                                </svg>
                            </div>
                            <span
                                v-html="$t('login_with_feide_privacy')"
                                class="flex justify-center items-center flex-wrap ml-2"
                            ></span>
                        </div>
                    </div>
                    <div class="mx-auto flex justify-center" style="margin-bottom: 2.6rem; max-width: 18rem">
                        <XButton @click="login" class="feide-button flex justify-center w-full">
                            <img src="@/assets/feide.webp" width="18" />
                            <span> Login med Feide </span>
                        </XButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '@/lib/user.js'
import Request from '@/lib/request.js'
import InnerLoader from '@/components/InnerLoader'
import XButton from '@/components/v2/XButton'
import thirdPartyLoginMixin from '@/mixins/3rd-party-login'
import helper from '@/lib/helper.js'
import helperMixins from '@/mixins/helper.js'
import AuthPopupMixin from '@/mixins/auth-popup'
import popup from '@/lib/popup.js'

export default {
    components: {
        XButton,
        InnerLoader
    },

    mixins: [thirdPartyLoginMixin, helperMixins, AuthPopupMixin],

    data() {
        return {
            isLoading: false,
            disabledWebView: false
        }
    },

    mounted() {
        this.$on('fail', () => {
            this.isLoading = false
        })
    },

    computed: {
        isDisabledClose() {
            return this.$route.name !== 'login-skoler'
        }
    },

    methods: {
        closePopup() {
            this.$store.commit('setShowFeideLogin', false)
        },

        closeByBackdrop(e) {
            if (!this.isDisabledClose) {
                return
            }

            if (!e.target.classList.contains('backdrop')) {
                return
            }
            if (this.isLoading == false) {
                this.closePopup()
            } else {
                this.isLoading = false
            }
        },

        isWebView() {
            return helper.webView()
        },

        login() {
            // just hardcode for disabled webview
            if (this.disabledWebView) {
                return popup.alert(this.$t('auth_header_3rd_party_not_available'))
            }

            this.isLoading = true

            if (this.isWebView()) {
                return this.tryRedirectLogin('feide', window.location.href)
            }

            this.tryLogin('feide')
                .then(payload => {
                    this.verifiedUser(payload.token)
                })
                .catch(() => {
                    this.isLoading = false
                })
        },

        verifiedUser(user) {
            const request = new Request()

            return new Promise((resolve, reject) => {
                request
                    .post(`${process.env.VUE_APP_API_BASE_URL}v2/auth/3rd-party-login`, user)
                    .then(res => {
                        const userService = new UserService()
                        userService.setToken(res.data.token)

                        if (res.data.is_created) {
                            helper.gTrackEvent('register', {
                                event_category: 'Register',
                                event_label: 'Feide_register'
                            })
                        }

                        this.loginSuccess(userService.getUser(), false, false)

                        this.triggerEventLoginSuccess(userService.getUser())

                        this.isLoading = false
                        resolve()
                    })
                    .catch(err => {
                        const res = err.response

                        this.isLoading = false

                        if (typeof res.data.data.status != 'undefined') {
                            return popup.alert(
                                res.data.data.status == 'suspended'
                                    ? this.translate('auth_login_alert_lock_account')
                                    : ''
                            )
                        }

                        reject()
                    })
            })
        },

        triggerEventLoginSuccess(user) {
            const loginSuccessEvent = new CustomEvent('login-success')
            window.dispatchEvent(loginSuccessEvent)

            const feideLoginSuccessEvent = new CustomEvent('feide-login-success', {
                detail: user
            })
            window.dispatchEvent(feideLoginSuccessEvent)

            this.closePopup()
        }
    }
}
</script>

<style lang="scss">
#feide-login-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;

    .backdrop {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background-color: #0006;
        z-index: -1;
    }

    .popup-content {
        display: flex;
        flex-direction: column;
        width: 500px;
        height: auto;
        border-radius: 6px;
        color: #333;
        background-color: #fff;
        margin: 40px 0.75rem;

        .popup-header {
            padding: 14px 14px 0 14px;

            .close-button {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                color: #6c757d;
                transition: color 0.2s, background-color 0.2s;

                &:hover {
                    color: #343a40;
                    background: #e9ecef;
                }
            }
        }

        .popup-body {
            padding: 14px;

            .login-box {
                font-size: 1.2rem;

                .header-login {
                    margin-bottom: 2.8rem;
                }
            }

            .feide-button {
                height: 44px !important;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
                background-color: #fff !important;
                color: rgb(34, 72, 154) !important;
                border-radius: 7px;
                border: 1px solid #ccc;
            }
        }
    }
}
</style>